import React, { useState } from "react";
import Select, { components } from "react-select";

import ReactCountryFlag from "react-country-flag";
import { updateUserPreference } from "../../redux/actions/userPreference/PreferenceActions";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import { getExchangeRateApi, getGeoLocationApi } from "../../api/publicApi";
import { toast } from "react-toastify";

const Control = ({ children, ...props }) => {
  const selectedValue = props.getValue()[0];

  return (
    <components.Control {...props}>
      <ReactCountryFlag countryCode={selectedValue?.country} c svg className="img-currency-flag" title={selectedValue?.country} />
      {children}
    </components.Control>
  );
};

function Option(props) {
  const { data, children, ...otherProps } = props;

  return (
    <components.Option {...otherProps}>
      <ReactCountryFlag
        countryCode={data.country}
        c
        svg
        style={{
          width: "1.5rem",
          height: "1.5rem",
        }}
        title="US"
      />
      {children}
    </components.Option>
  );
}

const CustomInput = (props) => {
  const inputProps = { ...props, maxLength: 5 };

  return <components.Input {...inputProps} />;
};

const options = [
  { value: "LKR", label: "LKR", country: "LK" },
  { value: "USD", label: "USD", country: "US" },
  { value: "GBP", label: "GBP", country: "GB" },
  // { value: "INR", label: "INR", country: "IN" },
  { value: "EUR", label: "EUR", country: "EU" },
  // { value: "AUD", label: "AUD", country: "AU" },
  // { value: "CAD", label: "CAD", country: "CA" },
];

async function handlePreferenceChange(currency = "USD", dispatch, setLoading) {
  try {
    setLoading(true);

    const res = await getExchangeRateApi({ targetCurrency: currency });

    const exchangeRate = res?.data?.exchangeRate || 1;

    dispatch(
      updateUserPreference({
        currency,
        exchange_rate: parseFloat(exchangeRate),
      })
    );
  } catch (error) {
    toast.error("Failed to change currency");

    dispatch(
      updateUserPreference({
        currency: "USD",
        exchange_rate: 1,
      })
    );
  } finally {
    setLoading(false);
  }
}

const CurrencySelector = () => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const currency = localStorage.getItem("currency");

  const currencyInState = useSelector((state) => state.user_preference.currency);

  useEffect(() => {
    async function getGeoLocation() {
      try {
        const geoLocation = await getGeoLocationApi();

        const countryCode = geoLocation.data?.countryCode;

        let selectedCurrency = options.find((option) => option.country === countryCode)?.value;

        if (!selectedCurrency) {
          selectedCurrency = options[0].value;
        }

        if (selectedCurrency) {
          handlePreferenceChange(selectedCurrency, dispatch, setLoading);
          localStorage.setItem("currency", selectedCurrency);
        }
      } catch (error) {}
    }

    if (currency) {
      handlePreferenceChange(currency, dispatch, setLoading);
    } else {
      getGeoLocation();
    }
  }, []);

  const SelectedCurrency = options.find((option) => option.value === currencyInState);

  async function handleChange(e) {
    handlePreferenceChange(e.value, dispatch, setLoading);
    localStorage.setItem("currency", e.value);
  }

  return (
    <Select
      options={options}
      defaultValue={options[1]}
      value={SelectedCurrency}
      onChange={handleChange}
      isDisabled={false}
      isLoading={loading}
      isClearable={false}
      isRtl={false}
      isSearchable={false}
      name="color"
      styles={{
        container: (provided) => ({
          ...provided,
          zIndex: 12,
          marginLeft: "auto",
          height: "30px",
        }),
        control: (provided) => {
          return {
            ...provided,

            pointerEvents: loading ? "none" : "auto",
            position: "relative",
            border: "var(--border-light)",
            borderRadius: "5px",
            padding: "0 10px",
            fontSize: "1rem",
            color: "black",
            backgroundColor: "white",
            cursor: "pointer",
            minHeight: "30px",
            minWidth: "100px",
            maxWidth: "150px",
            boxShadow: "none",

            "&:hover": {
              border: "var(--border-dark)",
            },
            "&:focus": {
              border: "var(--border-dark)",
              boxShadow: "0 0 0 0.25rem #c3c3e5 !important",
            },
            "&:active": {
              border: "var(--border-dark)",
              boxShadow: "0 0 0 0.25rem #c3c3e5 !important",
            },

            "@media only screen and (max-width: 468px)": {
              padding: "0",
              minWidth: "auto",
              width: "fit-content",
            },
          };
        },
        option: (provided) => ({
          ...provided,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "10px",
        }),
        valueContainer: (provided) => ({
          ...provided,
          padding: "0 8px",
        }),
        loadingIndicator: (provided) => ({
          ...provided,
          position: "absolute",
          left: 0,
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(0,0,0,0.05)",
          transition: "all 0.3s ease",
          "& span": {
            backgroundColor: "#8f7eb9",
          },
        }),

        menu: (provided) => ({
          ...provided,
          width: "100px",
          backgroundColor: "white",
          border: "var(--border-light)",
          borderRadius: "5px",
          boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          zIndex: 999,
        }),

        menuList: (provided) => ({
          ...provided,

          "&::-webkit-scrollbar": {
            width: "8px",

            "&-track": {
              backgroundColor: "transparent",
            },
            "&-thumb": {
              backgroundColor: "rgba(0,0,0,0.1)",
              borderRadius: "10px",
            },
          },
        }),
      }}
      components={{
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
        Control,
        Option,
        Input: CustomInput,
      }}
    />
  );
};

export default CurrencySelector;

// selected-currency
